import Cookies from 'js-cookie';
import request from '../network/networkconfig';
import dict from './dictionary';

function User(token, uid, uaccount, uname, zqcode, orgid, roles, marks, f_token, zqname, rolenames, fid) {
    this.token = token;
    this.uid = uid;
    this.uaccount = uaccount;
    this.uname = uname;
    this.zqcode = zqcode;
    this.orgid = orgid;
    this.roles = roles;
    this.marks = marks;
    this.f_token = f_token;
    this.zqname = zqname;
    this.rolenames = rolenames;
    this.fid = fid;
}
User.prototype.setToken = function(token){ this.token = token};
User.prototype.getToken = function(){ return this.token};
User.prototype.setUid = function(uid){ this.uid = uid};
User.prototype.getUid = function(){ return this.uid};
User.prototype.setUaccount = function(uaccount){ this.uaccount = uaccount};
User.prototype.getUaccount = function(){ return this.uaccount};
User.prototype.setUname = function(uname){ this.uname = uname};
User.prototype.getUname = function(){ return this.uname};
User.prototype.setZqcode = function(zqcode){ this.zqcode = zqcode};
User.prototype.getZqcode = function(){ return this.zqcode};
User.prototype.setOrgid = function(orgid){ this.orgid = orgid};
User.prototype.getOrgid = function(){ return this.orgid};
User.prototype.setRoles = function(roles){ this.roles = roles};
User.prototype.getRoles = function(){ return this.roles};
User.prototype.setMarks = function(marks){ this.marks = marks};
User.prototype.getMarks = function(){ return this.marks};
User.prototype.setF_token = function(f_token){ this.f_token = f_token};
User.prototype.getF_token = function(){ return this.f_token};
User.prototype.setZqname = function(zqname){ this.zqname = zqname};
User.prototype.getZqname = function(){ return this.zqname};
User.prototype.setRolenames = function(rolenames){ this.rolenames = rolenames};
User.prototype.getRolenames = function(){ return this.rolenames};
User.prototype.setF_id = function(fid){ this.fid = fid};
User.prototype.getF_id = function(){ return this.fid};



var security = {
    // 是否登陆
    isLogin: function() {
        return security.getUser();
    },
    // 验证token是否有效
    validateToken:  function() {
        var user = security.getUser();
        var token = user.getToken();

    },
    // 验证码登录
    loginCaptcha: function(username, password, captcha) {
        let data = new FormData();
        data.append("u",  username);
        data.append("p",  password);
        data.append("c",  captcha);
        data.append("type",  1);
        return request({
            url: '/login/auth',
            method: 'post',
            data: data
        });
    },
    // 退出
    logout: function() {
        Cookies.remove(dict.constants.COOKIE_NAME_USER)
    },
    // 获得当前登录用户信息
    getUser: function() {
        var userStr = Cookies.get(dict.constants.COOKIE_NAME_USER);
        if(userStr) {
            var userObj = JSON.parse(userStr);
            return new User(userObj.token, userObj.uid, userObj.uaccount, userObj.uname,
                userObj.zqcode, userObj.orgid, userObj.roles, userObj.marks, userObj.f_token,
                userObj.zqname, userObj.rolenames, userObj.fid);
        }
    },
    setUser: function(token, uid, uaccount, uname, zqcode, orgid, roles, marks, f_token, zqname, rolenames, fId) {
        Cookies.set(dict.constants.COOKIE_NAME_USER, new User(token, uid, uaccount, uname, zqcode, orgid, roles, marks, f_token, zqname, rolenames, fId));
    },
    updateUser: function(user) {
        Cookies.set(dict.constants.COOKIE_NAME_USER,
            new User(user.getToken(), user.getUid(), user.getUaccount(), user.getUname(),
            user.getZqcode(), user.getOrgid(), user.getRoles(), user.getMarks(), user.getF_token(), user.getZqname(), user.getRolenames(), user.getF_id()));
    },
    getToken: function() {
        var user = security.getUser();
        if(user) return user.getToken();
    },
    // token无效
    isTokenInvalidate: function(errorCode) {
        if(errorCode == 'B0006') {
            // reloginConfirm变量是为了让提示用户重新登录的框只显示一次
            if(!window.reloginConfirm) {
                window.reloginConfirm = true;
                Cookies.remove(dict.constants.COOKIE_NAME_USER)
                window.$vue_bus.$emit(dict.event.LOGOUT);
            }
            return true;
        }
        return false;
    },
    //是否有权限访问该资源
    isAuthInvalidate: function(errorCode) {
        if(errorCode == 'A0004') {
            return true;
        }
        return false;
    },
    authFilter: (sourceMenus) => {
        _clearMenuState(sourceMenus);
        var user = security.getUser();
        var userMarks = user.getMarks();
        if(userMarks && userMarks.length > 0) {
            for(var i = 0 ; i < userMarks.length; i++) {
                var userMark = userMarks[i];
                for(var j = 0 ; j < sourceMenus.length; j ++) {
                    var menu = sourceMenus[j];
                    menu.active = false;
                    if(!menu.show) {
                        if(menu.name.toUpperCase() == userMark.toUpperCase()) {
                            menu.show = true;
                            break;
                        }
                    }
                    // 没找到继续递归找
                    var find = [];
                    _authFilter(userMark, menu.children, find);
                    if(find[0]){
                        break;
                    }
                }
            }
        }
        return sourceMenus;
    },
    //是否有功能按钮权限
    hasAuth: function(mark){
        if(security.getUser().getMarks().indexOf(mark) != -1){
            return true;
        }
        return false;
    },
    //判断是否有角色
    hasRole: function(role){
        var roles = security.getUser().getRoles();
        return roles.indexOf(role) >= 0;
    }
}

export default security

function _authFilter(targetMark, sourceMenu, find){
    if(sourceMenu && sourceMenu.length > 0) {
        for(var k = 0 ; k < sourceMenu.length; k++) {
            var menu = sourceMenu[k];
            menu.active = false;
            if(!menu.show) {
                if(menu.name.toUpperCase() == targetMark.toUpperCase()) {
                    menu.show = true;
                    find[0] = true;
                    break;
                }
            }
            _authFilter(targetMark, menu.children, find);
        }
    }
}

function _clearMenuState(sourceMenus) {
    for(var i = 0 ; i < sourceMenus.length; i ++) {
        var menu = sourceMenus[i];
        menu.show = false;
        if(menu.children && menu.children.length > 0) {
            _clearMenuState(menu.children)
        }
    }
}



// WEBPACK FOOTER //
// ./src/support/security.js